import {
  Autocomplete,
  Avatar,
  Box,
  Button,
  Chip,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import { CustomButton } from "./ConstantDesigns";
import React, { useState } from "react";

const UserSearchAndDiplaySection = ({
  userDatas,
  selectedUser,
  setSelectedUser,
  isSubmitted,
  setIsSubmitted,
}) => {
  const [userSelection, setUserSelection] = useState(selectedUser);

  const onsubmitFunction = () => {
    setSelectedUser(userSelection);
    if (userSelection?.userID) {
      localStorage.setItem("selectedUser", JSON.stringify(userSelection));
    }
    setIsSubmitted(true);
  };
  const changeUserFunction = () => {
    setIsSubmitted(false);
  };
  const cancelFunction = () => {
    setIsSubmitted(true);
  };
  const clearUserFunction = () => {
    localStorage.removeItem("selectedUser");
    setSelectedUser(null);
    setIsSubmitted(false);
    setUserSelection(null)
  };
  return (
    <Box>
      <Box
        sx={{
          display: !isSubmitted ? "flex" : "none",
          gap: 1,
          my: 1,
          alignItems: "center",
        }}
      >
        <Autocomplete
          name={"userId"}
          fullWidth
          options={userDatas}
          getOptionLabel={(option) => option.name || ""}
          value={
            userDatas.find((u) => u.userID == userSelection?.userID) || null
          }
          onChange={(e, option) => setUserSelection(option)}
          sx={{
            "& .MuiInputLabel-root": {
              fontSize: "0.7rem",
              top: "-6px",
              transition: "top 0.2s ease",
            },
            "& .MuiInputLabel-shrink": {
              top: "2px",
            },
          }}
          renderInput={(params) => (
            <TextField
              disabled
              fullWidth
              autoComplete="off"
              {...params}
              label="User Filter"
              InputProps={{
                ...params.InputProps,
                sx: {
                  height: 35,
                  fontSize: "0.7rem",
                },
              }}
              InputLabelProps={{
                ...params.InputLabelProps,
                sx: { fontSize: "0.7rem" },
              }}
            />
          )}
        />
        <Box sx={{ display: "flex", gap: 1 }}>
          <CustomButton onClick={onsubmitFunction}>Submit</CustomButton>
          <CustomButton onClick={clearUserFunction}>Clear User</CustomButton>
          <CustomButton onClick={cancelFunction}>Cancel</CustomButton>
        </Box>
      </Box>

      <Box
        sx={{
          display: userSelection?.name ? "flex" : "none",
          gap: 2,
          alignItems: "center",
        }}
      >
        <Stack
          direction="row"
          alignItems="center"
          spacing={1.5}
          sx={{
            pl: 1,
            pr: 2,
            py: 0.5,
            borderRadius: 1,
            backgroundColor: "whitesmoke",
            width: "fit-content",
            boxShadow: 2,
          }}
        >
          <Avatar
            alt={userSelection?.name || "User"}
            src={`https://workspace.teaminterval.net/assets/employee/photo/passport_size/${userSelection?.photo}.jpg`}
            sx={{ width: 40, height: 40 }}
          />
          <Chip
            label={
              <Typography
                sx={{ fontSize: "0.65rem" }}
                variant="body2"
                fontWeight={300}
              >
                {userSelection?.name || "N/A"}
              </Typography>
            }
            color="primary"
            variant="filled"
            sx={{
              height: 22,
              px: 2,
            }}
          />
        </Stack>

        <CustomButton
          sx={{ display: isSubmitted ? "inline-flex" : "none" }}
          onClick={changeUserFunction}
        >
          Change User
        </CustomButton>
      </Box>
    </Box>
  );
};

export default React.memo(UserSearchAndDiplaySection);
